import { render, staticRenderFns } from "./TutorData.vue?vue&type=template&id=b410f700&scoped=true"
import script from "./TutorData.vue?vue&type=script&lang=js"
export * from "./TutorData.vue?vue&type=script&lang=js"
import style0 from "./TutorData.vue?vue&type=style&index=0&id=b410f700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b410f700",
  null
  
)

export default component.exports